const maxioApiBaseUrl = process.env.REACT_APP_MAXIO_CONNECT_API_BASE_URL;
const stripeApiBaseUrl = process.env.REACT_APP_STRIPE_CONNECT_API_BASE_URL;
// stripetest
// stripetest2020
var rmUsername = null;
var rmPassword = null;
var rmMaxioTokenInfo = null;

export const authenticationService = {
	getBaseUrl,
	login,
	logout,
	generateSfdcToken,
	generateMaxioSfdcToken,
	getSfdcUser,
	getMaxioSfdcUser,
	isLoggedIn,
	getAccessToken,
	getClientId,
	handleHttpError,
};

const axios = require('axios');

function login(username, password, self) {

	rmUsername = username;
	rmPassword = password;
	
	const data = {
		username: username,
		password: password,
	};
	const header = {
		'Content-Type': 'application/json',
	};
	return axios
		.post(stripeApiBaseUrl + '/authenticate', data, header)
		.then(function (response) {
			console.log('login response', response);
			response.data.apiBaseUrl = stripeApiBaseUrl;
			localStorage.setItem('accessToken', JSON.stringify(response.data));
			if (response.data.clientId > 0) {
				console.log('Not admin user... check the client in Maxio');
				loginMaxio(username, password, self);
			} else {
				self.setState({
					redirect2mainpage: true,
				});
			}
		})
		.catch(function (error) {
			if (!self.unmount)
				self.setState({
					error,
				});
		});
}

function loginMaxio(username, password, self) {
	const data = {
		username: username,
		password: password,
	};
	const header = {
		'Content-Type': 'application/json',
	};
	return axios
		.post(maxioApiBaseUrl + '/api/v1/authenticate', data, header)
		.then(function (response) {
			console.log('login response', response);
			if (response.data.subscriptionId) {
				response.data.apiBaseUrl = maxioApiBaseUrl;
				localStorage.setItem('accessToken', JSON.stringify(response.data));
				console.log('Client have subscription in Maxio... Overwrite accessToken');
			}
			self.setState({
				redirect2mainpage: true,
			});
		})
		.catch(function (error) {
			if (!self.unmount)
				self.setState({
					error,
				});
		});
}

function generateSfdcToken(code, callback) {
	return axios
		.get(getBaseUrl() + '/api/v1/sfdc-login-with-code/' + code, {
			headers: {
				Authorization: 'Bearer ' + getAccessToken(),
			},
		})
		.then(function (response) {
			console.log('generateSfdcToken response', response);
			callback(true);
		})
		.catch(function (error) {
			authenticationService.handleHttpError(error);
		});
}

function generateMaxioSfdcToken(code, callback) {
	const accessTokenString = localStorage.getItem('rmMaxioTokenInfo');
	const accessToken = JSON.parse(accessTokenString);
	const token = accessToken ? accessToken.token : 'Invalid-access-token';

	return axios
		.get(maxioApiBaseUrl + '/api/v1/sfdc-login-with-code/' + code, {
			headers: {
				Authorization: 'Bearer ' + token,
			},
		})
		.then(function (response) {
			console.log('generateSfdcToken response', response);
			callback(true);
		})
		.catch(function (error) {
			authenticationService.handleHttpError(error);
		});
}

function getSfdcUser(callback) {
	return axios
		.get(getBaseUrl() + '/api/v1/sfdc-user', {
			headers: {
				Authorization: 'Bearer ' + getAccessToken(),
			},
		})
		.then(function (response) {
			console.log('getSfdcUser response', response);
			if (response && response.data && response.data.email) {
				callback(response.data);
			} else {
				callback(null);
			}
		})
		.catch(function (error) {
			authenticationService.handleHttpError(error);
		});
}

function getMaxioSfdcUser(callback) {
	const data = {
		username: 'alibenamortestaccount',
		password: 'frgxuenr6c',
	};
	const header = {
		'Content-Type': 'application/json',
	};
	return axios
		.post(maxioApiBaseUrl + '/api/v1/authenticate', data, header)
		.then(function (response) {
			rmMaxioTokenInfo = response.data;
			localStorage.setItem('rmMaxioTokenInfo', JSON.stringify(rmMaxioTokenInfo));
			console.log('getMaxioSfdcUser - login rmMaxioTokenInfo', rmMaxioTokenInfo);
			getMaxioSfdcUserEx(callback);
		})
		.catch(function (error) {
			authenticationService.handleHttpError(error);
		});
}

function getMaxioSfdcUserEx(callback) {
	const accessTokenString = localStorage.getItem('rmMaxioTokenInfo');
	const accessToken = JSON.parse(accessTokenString);
	const token = accessToken ? accessToken.token : 'Invalid-access-token';
	return axios
		.get(maxioApiBaseUrl + '/api/v1/sfdc-user', {
			headers: {
				Authorization: 'Bearer ' + token,
			},
		})
		.then(function (response) {
			console.log('getMaxioSfdcUserEx response', response);
			if (response && response.data && response.data.email) {
				callback(response.data);
			} else {
				callback(null);
			}
		})
		.catch(function (error) {
			authenticationService.handleHttpError(error);
		});
}

function logout() {
	console.log('logout');
	localStorage.removeItem('accessToken');
	window.location.href = '/signin';
}

function isLoggedIn() {
	const accessTokenString = localStorage.getItem('accessToken');
	const accessToken = JSON.parse(accessTokenString);
	return accessToken && accessToken.token;
}

function getAccessToken() {
	try {
		const accessTokenString = localStorage.getItem('accessToken');
		const accessToken = JSON.parse(accessTokenString);
		return accessToken ? accessToken.token : 'Invalid-access-token';
	} catch (e) {
		console.log('getAccessToken() - Exception', e);
	}
}

function getClientId() {
	try {
		const accessTokenString = localStorage.getItem('accessToken');
		const accessToken = JSON.parse(accessTokenString);
		return accessToken ? accessToken.clientId : -1;
	} catch (e) {
		console.log('getAccessToken() - Exception', e);
	}
}

function getBaseUrl() {
	const accessTokenString = localStorage.getItem('accessToken');
	const accessToken = JSON.parse(accessTokenString);
	return accessToken ? accessToken.apiBaseUrl : "Unknown";
}

function handleHttpError(error) {
	try {
		if (error.response) {
			console.log(error.response.data);
			console.log(error.response.status);
			console.log(error.response.headers);
			if (error.response.status === 401) {
				logout();
			}
		} else if (error.request) {
			console.log(error.request);
		} else {
			console.log('Error', error.message);
		}
		console.log(error.config);
	} catch (e) {
		console.log('handleHttpError() - Exception', e);
	}
}
